import { useEffect } from "react";

const useClickOutsideExceptContextMenu = (ref, closeMenu, menuClass = "context-menu") => {

    
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If click is inside the context menu, do nothing
      if (ref.current && ref.current.contains(event.target)) {
        return;
      }
      // If click is anywhere else on the page, close the menu
      if (!event.target.closest(`.${menuClass}`)) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, closeMenu, menuClass]);
};

export default useClickOutsideExceptContextMenu;
